export default __webpack_public_path__ + "static/media/mosaic.86e6594c.png";